import React, { useState } from 'react'
import ForgotForm from './ForgotForm'
import PalexLogo from '../../header/PalexLogo'
import { useHistory } from 'react-router-dom'
import { usersApi } from '../../../api/usersApi'
import { routes } from '../../../constantes/routes'
import { swalAlertError, swalSuccessGeneral } from '../../../utils/swalAlert'
import CloseBtn from '../../buttons/CloseBtn'
import '../../../assests/styles/onboarding/login.scss'

const ForgotContainer = () => {
    const [email, setEmail] = useState("")
    const [isDisable, setIsDisable] = useState(false)

    const history = useHistory()

    const toLanding = () => {
        history.push(routes.LANDING)
    }

    const toLogin = () => {
        history.push(routes.LOGIN)
    }

    const validateForm = () => {
        return email.length > 0
    }

    const handleSubmit = async (event) => {
        event.preventDefault()
        await forgotPassword(email)
    }

    const handleChange = (e) => {
        setEmail(e.target.value)
    }

    const forgotPassword = async (put) => {
        try {
            setIsDisable(true)
            const response = await usersApi.forgotPassword({ email: put })
            if (response.statusText === "OK") {
                swalSuccessGeneral("Se ha enviado instrucciones de recuperacion al correo " + email)
                toLanding()
            }
        } catch (error) {
            swalAlertError(error.response.data || error.response)
            setIsDisable(false)
        }
    }
    return (
        <>
            <div className="header" style={{ position: "absolute", width: "100%" }}>
                <div className="header__close" onClick={toLogin}>
                    <CloseBtn/>
                </div>
            </div>
              <div className='frameless-login'>
                <div className="login-wrap">
                    <PalexLogo/>
                    <h2>Recuperar contraseña</h2>
                    <p className="orange-p">Escribe tu email y te enviaremos un mail de recuperación</p>
                    <ForgotForm
                        email={email}
                        handleSubmit={handleSubmit}
                        isDisable={isDisable || !validateForm()}
                        handleChange={handleChange}
                    />
                </div>
            </div>
        </>
    )
}

export default ForgotContainer
